import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

type InitiateSpvRequest = {
  token: string;
};

const initiateSpv = async ({ token }: InitiateSpvRequest) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/trade-directory/users/initiate-spv`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default initiateSpv;
